export const AgreementOverviewTabs = {
    AMENDMENTS: 'AMENDMENTS',
    ATTACHMENTS: 'ATTACHMENTS',
    OBLIGATIONS: 'OBLIGATIONS',
    OVERVIEW: 'OVERVIEW',
    CONTACTS: 'CONTACTS'
} as const;
